var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcxTrendRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.627447 0.675734C0.358559 0.910053 0.358559 1.28995 0.627447 1.52427L6.33743 6.50001L0.627447 11.4758C0.358559 11.7101 0.358559 12.09 0.627447 12.3243C0.896342 12.5586 1.33231 12.5586 1.60119 12.3243L7.79803 6.92427C8.0669 6.68997 8.0669 6.31005 7.79803 6.07575L1.60119 0.675734C1.33231 0.441422 0.896342 0.441422 0.627447 0.675734Z",
    fill: "#D71F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcxTrendRedIcon);
export default __webpack_public_path__ + "static/media/ncx-trend-red-icon.b3c9128dae550d168453627b1bca8239.svg";
export { ForwardRef as ReactComponent };